import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfirmationDisclaimer.css';
import { Label as LabelUI, Paragraph, Toggle } from 'ui-library';

const ConfirmationDisclaimer = ({
    text,
    onChange,
    value,
    error,
    agreeOnText,
}) => {
    const { t } = useTranslation();

    return (
        <div className="confirmation-disclaimer">
            <Paragraph type="secondary">{text}</Paragraph>
            <LabelUI label={t('confirmation.confirmation')}/>
            <div className="toggle-block">
                <Toggle
                    value={value}
                    onChange={onChange}
                />
                <span>{agreeOnText}</span>
            </div>
            {error && <div className="error-message">{error}</div>}
        </div>
    );
};

export default ConfirmationDisclaimer;
